/**
 * App Version — bump this string every time you deploy a new version.
 * The app will compare it against the value stored in localStorage.
 * If they differ, it clears ALL stale caches/storage so the user gets a fresh load from the server.
 */
export const APP_VERSION = "48.48.48";

const STORAGE_KEY = "app_version";

export function checkAppVersion(): void {
  if (typeof window === "undefined") return;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored && stored !== APP_VERSION) {
      console.log(`[AppVersion] New version detected: ${APP_VERSION} (was ${stored}). Purging stale caches...`);

      // Version changed → Purge ALL app state and old cached data completely
      localStorage.clear();
      sessionStorage.clear();

      // Unregister Service Workers if any to ensure fresh JS/HTML assets
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((regs) => {
          regs.forEach((r) => r.unregister());
        });
      }

      // Delete Cache Storage entries
      if ("caches" in window) {
        caches.keys().then((keys) => {
          keys.forEach((k) => caches.delete(k));
        });
      }

      // Re-store the new version after clearing
      localStorage.setItem(STORAGE_KEY, APP_VERSION);

      // Hard reload to fetch fresh assets and fresh API data from server
      window.location.reload();
      return;
    }

    // First visit or same version — persist it
    localStorage.setItem(STORAGE_KEY, APP_VERSION);
  } catch {
    // Storage blocked — ignore
  }
}
